<tidy-text [body]="inputTitle" />
<div
  [id]="'customMessage-' + id"
  contenteditable="true"
  class="custom-message"
  [class.invalid]="control.invalid && control.touched"
  [class.readonly]="readonly">
</div>
@if (control.invalid && control.touched) {
  <tidy-error-message
    [text]="inputTitle + (' is required.' | translate)"
    class="error-message" />
}
